import React, { useState, useEffect } from 'react';
import {
  Container,
  VStack,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Text,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import axios from 'axios';

const Dashboard = () => {
  const [urls, setUrls] = useState([]);
  const [selectedQR, setSelectedQR] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  useEffect(() => {
    fetchUrls();
  }, []);

  const fetchUrls = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('http://localhost:5000/api/url/my-urls', {
        headers: { 'x-auth-token': token }
      });
      setUrls(res.data);
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to fetch URLs',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`http://localhost:5000/api/url/${id}`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.status === 200) {
        setUrls(urls.filter(url => url._id !== id));
        toast({
          title: 'Success',
          description: 'URL deleted successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Delete error:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to delete URL',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const showQRCode = async (shortUrl) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post('http://localhost:5000/api/url/shorten', 
        {
          originalUrl: `http://localhost:5000/api/url/${shortUrl}`
        },
        {
          headers: { 'x-auth-token': token }
        });
      setSelectedQR(res.data.qrCode);
      onOpen();
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to generate QR code',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Container maxW="container.xl" py={10}>
      <VStack spacing={8} align="stretch">
        <Heading>Your URLs</Heading>
        {urls.length === 0 ? (
          <Text>No URLs found. Create one from the home page!</Text>
        ) : (
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Original URL</Th>
                <Th>Short URL</Th>
                <Th>Clicks</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {urls.map((url) => (
                <Tr key={url._id}>
                  <Td>{url.originalUrl}</Td>
                  <Td>
                    <div>
                      <Text mb={2}>Short URL: 
                        <a
                          href={`http://localhost:5000/api/url/${url.shortUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: 'blue', marginLeft: '5px', textDecoration: 'underline' }}
                        >
                          {`http://localhost:5000/api/url/${url.shortUrl}`}
                        </a>
                      </Text>
                      <Text>Original URL: 
                        <a
                          href={url.originalUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: 'green', marginLeft: '5px', textDecoration: 'underline' }}
                        >
                          {url.originalUrl}
                        </a>
                      </Text>
                    </div>
                  </Td>
                  <Td>{url.clicks}</Td>
                  <Td>
                    <Button
                      size="sm"
                      colorScheme="blue"
                      mr={2}
                      onClick={() => showQRCode(url.shortUrl)}
                    >
                      QR Code
                    </Button>
                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => handleDelete(url._id)}
                    >
                      Delete
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </VStack>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>QR Code</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {selectedQR && <Image src={selectedQR} alt="QR Code" />}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default Dashboard;
